export default class BaseEntity {
    parseProperty(data, name) {
        if (Object.prototype.hasOwnProperty.call(data, name)) {
            return data[name];
        }
        throw new Error(`Attribute '${name}' is not present in data. Try one of [${Object.keys(data).join(', ')}]`);
    }
}
